import React, { Component } from 'react';
import { NavLink } from 'react-router-dom';
import { strings } from 'APP_ROOT/localization';
import Modal from 'react-modal';

export default class OverdueModal extends Component {

    // Do we want page view analytics?

    render() {

        return (
            <Modal
                isOpen={this.props.isOpen}
                contentLabel="edit-plan-modal"
                className="react-modal-content react-modal-sm"
                overlayClassName="react-modal-overlay"
                onRequestClose={this.props.onRequestClose}
                onAfterOpen={this.props.onAfterOpen}>

                <div className="container-fluid form-card">

                    <h2>{strings.account_overdue_ravens_title}</h2>

                    <div className="row">

                        <div className="col-12">
                            <p>{strings.account_overdue_ravens_message_1}</p>
                            <p>{strings.account_overdue_ravens_message_2}</p>
                            <p>{strings.account_overdue_ravens_message_3}</p>
                            <p><button className="btn btn-blue btn-sm" onClick={this.props.onRequestClose} >{strings.action_dismiss}</button> </p>
                        </div>
                    </div>
                </div>
            </Modal>
        );
    }
}
